import "%modules%/header/header";
import "%modules%/intro/intro";
import "%modules%/who-are-we/who-are-we";
import "%modules%/development-of-chat-bots/development-of-chat-bots";
import "%modules%/what-our-bots-can/what-our-bots-can";
import "%modules%/integration-features/integration-features";
import "%modules%/what-bots-do-we-make/what-bots-do-we-make";
import "%modules%/what-technologies-do-we-use/what-technologies-do-we-use";
import "%modules%/examples-of-our-bots/examples-of-our-bots";
import "%modules%/order-block/order-block";
import "%modules%/trust-us/trust-us";
import "%modules%/footer/footer"
import "%modules%/modal/modal"